<template>
  <div v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta && isShowLink(onlyOneChild)" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">

          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title"
                :badge="onlyOneChild.meta.title=='缴费管理'?renew:onlyOneChild.meta.title=='功能开通申请'?fun:'0'"></item>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title"
              :badge="item.meta.title=='费用管理'?costTotal:'0'"/>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import {isExternal} from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import {mapGetters} from "vuex";

export default {
  name: 'SidebarItem',
  components: {Item, AppLink},
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'costTotalNum',//费用管理总统计
      'renewNum',//缴费管理数量
      'funNum',//功能开通申请数量
      'roleType'//用户类型
    ])
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      costTotal: '0',//费用管理总统计
      renew: '0',//缴费管理数量
      fun: '0',//功能开通申请数量
    }
  },
  mounted() {
    this.init()
  },
  watch:{
    costTotalNum(val){
      if(val){
        this.init()
      }
    },
    renewNum(val){
      if(val){
        this.init()
      }
    },
    funNum(val){
      if(val){
        this.init()
      }
    }
  },
  methods: {
    isShowLink(onlyOneChild){
      let hideTileList = ['企业设置'];

      if(hideTileList.includes(onlyOneChild.meta.title) && (this.roleType == '1' || this.roleType == '2')) {
        return false
      }
      return true
    },

    init() {
      this.costTotal = String(Number(this.costTotalNum) >= 9999999 ? '9999999+' : this.costTotalNum || '0');
      // this.costTotal = String(this.costTotalNum || '0');
      this.renew = String(Number(this.renewNum) >= 9999999 ? '9999999+' : this.renewNum || '0');
      // this.renew = String(this.renewNum || '0');
      this.fun = String(Number(this.funNum) >= 9999999 ? '9999999+' : this.funNum || '0');
      // this.fun = String(this.funNum || '0');
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style scoped>
/deep/ .nest-menu .el-menu-item {
  padding-left: 50px !important;
}

.custom-badge {
  background: #ff0000;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  height: 18px;
  min-width: 18px;
  padding: 0 4px 0 2px;
  line-height: 18px;
  display: inline-block;
  margin-left: 5px;
  font-size: 12px;
  vertical-align: 1px;
}
</style>
